export const ACTION = "action";
export const ALERT = "alert";
export const BINDER_HEADER = "binderInfo";
export const COLLAPSE_IDXS = "c[]";
export const COMPARISON = "comparison";
export const DIALOG = "dialog";
export const ERROR = "error";
export const EXPAND_ALL = "e";
export const EXPAND_IDXS = "e[]";
export const INTRO = "intro";
export const PRINT = "print";
export const PROFILE_ID = "profileId";
export const PROFILE_IDS = "profileIds[]";
export const PROFILE_IDS_2 = "profileIds";
export const PROFILE_TYPE = "profileType";
export const REPORT_DOWNLOAD_ID = "downloadReportId";
export const SEARCH_BUTTON = "search";
export const SEARCH_DRAWER_OPEN = "openSearchDrawer";
export const SEARCH_MEMO = "searchMemo";
export const TAB_IDS = "tabIds[]";
